var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { makeObservable, observable, action } from "mobx";
export class WebViewUserState {
    constructor() {
        this.topposition = 30;
        this.leftposition = 200;
        this.width = window.innerWidth < 600 ? window.innerWidth - 50 : 550;
        this.height = window.innerHeight < 550 ? window.innerHeight - 50 : 500;
        this.dragging = false;
        this.show = false;
        this.selectedformusers = new Set();
        this.otherorgUsers = [];
        this.othersitems = [];
        this.permissionforusers = new Map();
        this.readonlyitems = new Map();
        this.initialboxusers = new Map();
        this.initalformusers = [];
        makeObservable(this);
    }
    addOtherItems(items) {
        this.othersitems.splice(0, this.othersitems.length);
        this.othersitems.push(...items);
    }
    addPermissionForUser(id, perm) {
        var _a;
        if (!this.permissionforusers.has(id)) {
            this.permissionforusers.set(id, new Set());
        }
        (_a = this.permissionforusers.get(id)) === null || _a === void 0 ? void 0 : _a.add(perm);
    }
    addReadOnlyForUser(id, perm) {
        var _a;
        if (!this.readonlyitems.has(id)) {
            this.readonlyitems.set(id, new Set());
        }
        (_a = this.readonlyitems.get(id)) === null || _a === void 0 ? void 0 : _a.add(perm);
    }
    removeReadOnlyForUser(id, perm) {
        var _a;
        (_a = this.readonlyitems.get(id)) === null || _a === void 0 ? void 0 : _a.delete(perm);
    }
    removePermissionForUser(id, perm) {
        var _a;
        (_a = this.permissionforusers.get(id)) === null || _a === void 0 ? void 0 : _a.delete(perm);
    }
    setShow(show) {
        this.show = show;
    }
    setDragging(drag) {
        this.dragging = drag;
    }
    setToppos(pos) {
        this.topposition = pos;
    }
    setLeftPos(pos) {
        this.leftposition = pos;
    }
    setAppUser(id) {
        this.selectedformusers.add(id);
    }
    getOtherOrgUsers() {
        return this.otherorgUsers.sort((v1, v2) => v1.name.toLowerCase().localeCompare((v2.name.toLowerCase())));
    }
    setFormUsers(fu) {
        this.otherorgUsers.splice(0, this.otherorgUsers.length);
        this.otherorgUsers.push(...fu);
    }
    removeAppUser(id) {
        this.selectedformusers.delete(id);
    }
    resetToOrig() {
        this.selectedformusers.clear();
        this.permissionforusers.clear();
        this.readonlyitems.clear();
        if (this.initalformusers) {
            for (const f of this.initalformusers) {
                const myb = this.initialboxusers.get(f.id);
                if (!myb)
                    continue;
                this.setAppUser(f.id);
                for (const pm of myb.mypermissions) {
                    this.addPermissionForUser(f.id, pm);
                }
                for (const pm of myb.readonlyfields) {
                    this.addReadOnlyForUser(f.id, pm);
                }
            }
            this.setFormUsers(this.initalformusers);
        }
    }
    reset() {
        this.resetToOrig();
        this.setFormUsers([]);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewUserState.prototype, "topposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewUserState.prototype, "leftposition", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewUserState.prototype, "width", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewUserState.prototype, "height", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewUserState.prototype, "dragging", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], WebViewUserState.prototype, "show", void 0);
__decorate([
    observable,
    __metadata("design:type", Set)
], WebViewUserState.prototype, "selectedformusers", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], WebViewUserState.prototype, "otherorgUsers", void 0);
__decorate([
    observable,
    __metadata("design:type", Array)
], WebViewUserState.prototype, "othersitems", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], WebViewUserState.prototype, "permissionforusers", void 0);
__decorate([
    observable,
    __metadata("design:type", Map)
], WebViewUserState.prototype, "readonlyitems", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "addOtherItems", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "addPermissionForUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "addReadOnlyForUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "removeReadOnlyForUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String, String]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "removePermissionForUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "setShow", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "setDragging", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "setToppos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Number]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "setLeftPos", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "setAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Array]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "setFormUsers", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "removeAppUser", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "resetToOrig", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], WebViewUserState.prototype, "reset", null);
